import { useCallback } from 'react';
import { useForm } from 'react-hook-form';

import Icon from '@/components/Icon';

type SearchProps = {
	searchStr: string;
	onCancel: any;
	onSubmit: any;
};

export default function Search({
	searchStr,
	onCancel = () => {},
	onSubmit = () => {}
}: SearchProps ) {
	const { handleSubmit, register, reset } = useForm({
		defaultValues: {
			recordSearch: searchStr
		}
	});

	const formCancel = useCallback( () => {
		onCancel();

		reset();
	}, [ onCancel, reset ] );

	return (
		<form onSubmit={ handleSubmit( onSubmit ) }>
			<div className="relative flex w-full">
				<div className="relative flex w-full">
					<input
						id="record-search"
						type="search"
						placeholder="Enter a client name, client number, or application ID..."
						className="border border-rural-gray-700 rounded-md p-3 w-full rounded-r-none"
						{ ...register( 'recordSearch' ) }
					/>

					{ searchStr && (
						<button
							type="button"
							className="absolute right-4 top-[50%] -translate-y-[54%] text-rural-gray-600 font-bold text-2xl"
							onClick={ formCancel }
						>
							&times;
						</button>
					)}
				</div>

				<button
					type="submit"
					onClick={ () => {} }
					className="bg-rural-gray-100 border border-rural-gray-700 p-3 rounded-md rounded-l-none border-l-0"
				>
					<Icon glyph="search" color="#a4a4a4" />
				</button>
			</div>
		</form>
	);
}
